import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_inventory_count_tasksService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryCountIds: number[], statusIds?: number[], operationCodeIds?: number[] }): 
  Promise<{ result: { TaskId?: number, Task?: { Id?: number, ChainHead?: number, CompletedDateTime?: string, StatusId?: number, OperationCode?: { Id?: number, Name?: string }, Status?: { Name?: string }, InventoryCountDiscrepancies?: { StatusId?: number }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryCountIds)) {
      missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryCountIds: number[], statusIds?: number[], operationCodeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TaskId?: number, Task?: { Id?: number, ChainHead?: number, CompletedDateTime?: string, StatusId?: number, OperationCode?: { Id?: number, Name?: string }, Status?: { Name?: string }, InventoryCountDiscrepancies?: { StatusId?: number }[] } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryCountIds)) {
      missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryCountIds: number[], statusIds?: number[], operationCodeIds?: number[], $keys: number[] }): 
  Promise<{ result: { TaskId?: number, Task?: { Id?: number, ChainHead?: number, CompletedDateTime?: string, StatusId?: number, OperationCode?: { Id?: number, Name?: string }, Status?: { Name?: string }, InventoryCountDiscrepancies?: { StatusId?: number }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryCountIds)) {
      missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryCountIds: number[], statusIds?: number[], operationCodeIds?: number[]    }) {
        if(isNil(inParams.inventoryCountIds)) {
          return true; 
        }
      return false;
    }
}
